import { Dropdown, Form, Button, Table } from "react-bootstrap";
import { useEffect, useState, useRef } from "react";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import { Link, useSearchParams } from "react-router-dom";
import "./../../assets/scss/scoped/invoicelist.scoped.scss";
import useDebounce, {
  useEffectOnce,
  useIsHMB,
  useIsRSMOH,
  useQueryParams,
} from "../../utils/hooks";
import Select from "react-select";
import CachedIcon from "mdi-react/CachedIcon";
import NewCustomerModal from "../NewCustomerModal";
import { queryActions } from "../../utils/reactQueryActions";
import { useMutation, useQuery } from "react-query";
import queryString from "query-string";
import { useStoreActions, useStoreState } from "easy-peasy";
import { services } from "../../config";
import {
  customerFullName,
  customerTypeOptions,
  didYouKnowOptions,
  formatDate,
  paginationOptions,
  searchParamsToObject,
} from "../../utils/helpers";
import { useAuth } from "../../hooks/useAuth";
import ReactPaginate from "react-paginate";
import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
import SetSalesRepModal from "./SetSalesRepModal";
import { format } from "date-fns";
import currency from "currency.js";
import {
  DeleteIcon,
  EditIcon,
  FileListIcon,
  ViewIcon,
  QuotationIcon,
  UserIcon,
  ExportIcon,
  ExcelIcon,
} from "../Icons";
import EditCustomerModal from "../EditCustomerModal";
import { toast } from "react-toastify";
import ModalLoader from "../utils/ModalLoader";
import CustomerProducts from "../CustomerProducts";
import { isEmpty, uniqBy } from "lodash";
import { useDownloadExcel } from "../../hooks/useDownloadExcel";
import { CSVLink } from "react-csv";
import NoTableItem from "../utils/NoTableItem";
import ConfirmDialog from "../ConfirmDialogue";

const registeredFromOptions = [
  {
    label: "All",
    value: "All",
  },
  {
    label: "Online Store",
    value: "Online Store",
  },
];

export function HMBCustomerList({ Dept = "All" }) {
  const isHMB = useIsHMB();
  const isRSMOH = useIsRSMOH();
  const [searchParams] = useSearchParams();
  const { backendUrl, token } = useAuth();
  const [showCreateNewCustomerModal, setShowCreateNewCustomerModal] = useState(
    false
  );
  const [showEditCustomerModal, setShowEditCustomerModal] = useState(false);

  const [showProductModal, setShowProductModal] = useState(false);

  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [showSalesRepManager, setShowSalesRepManager] = useState(null);

  // fetch excel hook
  const [excelData, setExcelData] = useState([]);
  const CSVLinkRef = useRef(null);
  const [isfetchingExcel, fetchExcelData] = useDownloadExcel(
    excelData,
    CSVLinkRef
  );

  const initialFilterParams = {
    q: "",
    page: 1,
    limit: 40,
    Dept,
    withCredit: true,
    balanceExternal: isHMB || isRSMOH,
    withLastPayment: true,
  };

  const [queryParams, setQueryParams] = useQueryParams({
    ...initialFilterParams,
  });
  const [filterParams, setFilterParams] = useState({
    ...initialFilterParams,
    ...queryParams,
  });
  const debouncedFilterParams = useDebounce(filterParams, 500);

  const generalSettings = useStoreState((state) => state.generalSettings);

  useEffect(() => {
    setQueryParams({ ...queryParams, ...debouncedFilterParams });
  }, [debouncedFilterParams]);

  // action form url query on render once
  useEffectOnce(() => {
    const queryParams = searchParamsToObject(searchParams.entries());
    if (queryParams?.action === "create") {
      setShowCreateNewCustomerModal(true);
      // delete queryParams.action;
      setQueryParams({ ...initialFilterParams });
    }
  });

  const handleSearchQueryChange = (e) => {
    setFilterParams({
      ...filterParams,
      [e.target.name]: e.target.value,
    });
  };

  const getCustomer = async (debouncedqueryParams) => {
    let response = await fetch(
      `${backendUrl}/api/customers?${queryString.stringify(
        debouncedqueryParams
      )}`,
      {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
          Authorization: `Bearer ${token}`,
        },
        credentials: "include",
      }
    );
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const { data } = await response.json();

    data.customerTypes = uniqBy(
      [
        // ...customerTypeOptions,
        ...data.customerTypes
          .filter((el) => el.TransType)
          .map((el) => ({
            value: el.TransType,
            label: el.TransType,
          })),
      ],
      "value"
    );

    data.groups = uniqBy(
      [
        ...data.groups
          .filter((el) => el.Group)
          .map((el) => ({
            value: el.Group,
            label: el.Group,
          })),
      ],
      "value"
    );
    return data;
  };

  const {
    data = { customers: [], groups: [], customerTypes: [] },
    refetch,
    isFetching,
    isSuccess,
  } = useQuery(
    [queryActions.CUSTOMERS, queryParams],
    () => getCustomer(queryParams),
    {
      enabled: true,
      keepPreviousData: true,
    }
  );

  const deleteCustomer = async (payload) => {
    let response = await fetch(`${backendUrl}/api/customers/delete`, {
      method: "POST",
      // credentials: "include",
      body: JSON.stringify(payload),
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
    });
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };
  const deleteCustomerMutation = useMutation(
    (payload) => deleteCustomer(payload),
    {
      onSuccess: ({ message, data }) => {
        refetch();
        toast.success(message);
      },
      onError: () => {
        toast.error(`Unable to perform action`);
      },
    }
  );

  const manageSalesRep = (el) => {
    setSelectedCustomer(el);
    setShowSalesRepManager(true);
  };

  const editCustomer = (customer) => {
    setSelectedCustomer(customer);
    setShowEditCustomerModal(true);
  };

  const onDownloadExcelData = async () => {
    const { limit, page, ...rest } = queryParams;
    let exData = await fetchExcelData(
      `${backendUrl}/api/customers?${queryString.stringify(rest)}`,
      "GET"
    );

    exData = exData?.data?.customers?.map((d, i) => [
      data?.startIndex + i + 1,
      d?.Cust_ID,
      customerFullName(d),
      d?.TransType,
      d?.PhoneNo1,
      d?.ContactAddress || "...",
      d?.CompanyAddress || "...",
      d?.Email || "...",
      d?.How_Did_Know,
      d?.DateLog,
      d.DOB ? format(new Date(d.DOB), "dd MMM") : "...",
      currency(d?.Customer_CreditLimit?.CreditLimit, {
        symbol: "",
      }).format(),
      d?.Branch,
    ]);
    const date =
      rest.startDate && rest.endDate
        ? `Date Prepared: Between ${format(
            new Date(rest.startDate),
            "E MMM d yyyy k:mm:ss z"
          )} to ${format(new Date(rest.endDate), "E MMM d yyyy k:mm:ss z")}`
        : "";
    exData = [
      ["Customers Report"],
      [date],
      [""],
      [
        "S/N",
        "Cust ID",
        "Business Name",
        "Transaction Type",
        "Phone",
        "Contact Address",
        "Company Address",
        "Email",
        "Acquisition",
        "DateLog",
        "DOB",
        "Credit Limit",
        "Branch",
      ],
      ...exData,
      [""],
    ];
    console.log(exData);
    setExcelData(exData);
  };

  return (
    <main className="cash-book">
      {" "}
      <div className="content">
        <header className="py-4">
          <div
            className="search-area d-flex flex-wrap justify-content-between gap-3 w-100"
            style={{ zIndex: 10 }}
          >
            <div className="d-flex flex-wrap gap-3 align-items-center">
              <h1 className="fs-6">Customers</h1>

              <div className="d-flex flex-wrap gap-3">
                <div className="global-search-area">
                  <MagnifyIcon />
                  <Form.Control
                    id="queryParams-q"
                    className=""
                    name="LastName"
                    value={filterParams.LastName}
                    onChange={(e) => handleSearchQueryChange(e)}
                    placeholder="Search..."
                  />
                </div>
                <Button
                  onClick={() => refetch()}
                  variant=""
                  className="bg-light-blue border-0 text-primary"
                >
                  <CachedIcon />
                </Button>
              </div>
            </div>

            <div
              className="d-flex flex-wrap gap-3"
              style={{ fontSize: "0.875rem" }}
            >
              <Form.Group>
                <Select
                  classNamePrefix="form-select"
                  menuPosition="fixed"
                  menuPlacement="auto"
                  placeholder="Select Category"
                  name="TransType"
                  isSearchable={true}
                  onChange={(selected) => {
                    setFilterParams({
                      ...filterParams,
                      TransType: selected?.value,
                    });
                  }}
                  value={data.customerTypes?.find(
                    (el) => el.value === filterParams.TransType
                  )}
                  options={data.customerTypes || []}
                  isClearable
                />
              </Form.Group>
              <Form.Group>
                <Select
                  classNamePrefix="form-select"
                  menuPosition="fixed"
                  menuPlacement="auto"
                  placeholder="Select Group"
                  name="Group"
                  isSearchable={true}
                  onChange={(selected) => {
                    setFilterParams({
                      ...filterParams,
                      Group: selected?.value,
                    });
                  }}
                  value={data.groups?.find(
                    (el) => el.value === filterParams.Group
                  )}
                  options={data.groups || []}
                  isClearable
                />
              </Form.Group>
              <CSVLink
                className="btn print d-none"
                filename={`Customers Report(${format(
                  new Date(),
                  "dd-MMM-yyyy hh:mm:ss a"
                )}).csv`}
                data={excelData}
                ref={CSVLinkRef}
              />
              <Dropdown>
                <Dropdown.Toggle
                  variant=""
                  className="btn print"
                  disabled={isfetchingExcel}
                  bsPrefix=""
                >
                  Export
                  <ExportIcon color="#008000" />
                </Dropdown.Toggle>
                <Dropdown.Menu
                  popperConfig={{
                    strategy: "fixed",
                  }}
                  renderOnMount
                  className="text-center"
                >
                  <Dropdown.Item
                    as="div"
                    onClick={onDownloadExcelData}
                    className="p-cursor"
                  >
                    Excel <ExcelIcon color="#008000" />
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>{" "}
            </div>
          </div>
        </header>

        <div className="content px-4 pb-4">
          <Table borderless striped responsive className="product-table">
            <thead className="sticky border-bottom">
              <tr>
                <th />
                <th>Business Name</th>
                <th>Category</th>
                <th>Phone</th>
                <th>Total Sales</th>
                {isRSMOH && <th>Total Incentive</th>}
                <th>Amount Owed</th>
                <th>Aging Days</th>
                <th>Last Payment</th>
              </tr>
            </thead>

            <tbody className="blue-hover">
              {data.customers &&
                data.customers.map((el, index) => (
                  <tr key={index}>
                    <td>
                      <Dropdown>
                        <Dropdown.Toggle
                          variant=""
                          className="bg-white border-0"
                          bsPrefix="print more"
                        >
                          <DotsVerticalIcon />
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                          popperConfig={{
                            strategy: "fixed",
                          }}
                          renderOnMount
                          className="dropdown-with-icons"
                        >
                          {isHMB && (
                            <>
                              {" "}
                              <Link
                                to={`/hmb-rsmoh/pending-proforma?customerId=${
                                  el.Cust_ID
                                }&startDate=&endDate=&customerName=${customerFullName(
                                  el
                                )}&Status=Pending`}
                                state={{ customer: el, customerId: el.Cust_ID }}
                              >
                                <Dropdown.Item as="button">
                                  <ViewIcon />
                                  View Pending Proforma
                                </Dropdown.Item>
                              </Link>
                              <Link
                                to={`/hmb-rsmoh/approved-proforma?customerId=${
                                  el.Cust_ID
                                }&startDate=&endDate=&customerName=${customerFullName(
                                  el
                                )}&Status=Approved`}
                                state={{ customer: el, customerId: el.Cust_ID }}
                              >
                                <Dropdown.Item as="button">
                                  <ViewIcon />
                                  View Approved Proforma
                                </Dropdown.Item>
                              </Link>
                            </>
                          )}

                          <Link
                            to={`/hmb-rsmoh/sales-analysis?customerId=${
                              el.Cust_ID
                            }&startDate=&endDate=&customerName=${customerFullName(
                              el
                            )}`}
                            state={{ customer: el, customerId: el.Cust_ID }}
                          >
                            <Dropdown.Item as="button">
                              <ViewIcon />
                              View Customer Purchase
                            </Dropdown.Item>
                          </Link>

                          <Link
                            to={`/hmb-rsmoh/customer-ledger?customerId=${
                              el.Cust_ID
                            }&customerName=${customerFullName(el)}`}
                          >
                            <Dropdown.Item as="button">
                              <ViewIcon />
                              View Customer Ledger
                            </Dropdown.Item>
                          </Link>
                        </Dropdown.Menu>{" "}
                      </Dropdown>
                    </td>
                    <td title={el.Cust_ID}>{customerFullName(el)}</td>
                    <td>{el.TransType}</td>
                    <td>{el.PhoneNo1}</td>
                    <td>
                      {currency(el?.totalSales, {
                        symbol: "",
                      }).format()}
                    </td>
                    {isRSMOH && (
                      <td>
                        {currency(el?.totalIncentive, {
                          symbol: "",
                        }).format()}
                      </td>
                    )}
                    <td title={el?.balance}>
                      {currency(el?.balance, {
                        symbol: "",
                      }).format()}
                    </td>
                    <td>{el?.agingDays || "..."}</td>
                    <td>
                      {currency(el?.lastPayment?.Credit, {
                        symbol: "",
                      }).format()}{" "}
                      - {el?.Post_Time ? formatDate(el?.Post_Time) : "..."}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>

          {!isFetching && isSuccess && isEmpty(data?.customers) ? (
            <NoTableItem queryParams={queryParams} />
          ) : null}
        </div>

        <div className="d-flex justify-content-between px-3 align-items-center pagination pb-4">
          {/*<p className="m-0">
                Showing {data?.startIndex + 1} to{" "}
                {data?.endIndex <= data?.count ? data?.endIndex : data?.count}{" "}
                of {data.count} entries
                  </p> */}
          <div className="pagination_left d-flex gap-3 align-items-center">
            <p className="m-0 p-0">Show</p>
            <select
              value={queryParams.limit}
              name="limit"
              className="form-select "
              onChange={(e) => handleSearchQueryChange(e)}
            >
              <option value="10">10 rows</option>
              <option value="20">20 rows</option>
              <option value="30">30 rows</option>
              <option value="40">40 rows</option>
              <option value="50">50 rows</option>
              <option value="100">100 rows</option>
            </select>
          </div>

          <ReactPaginate
            {...paginationOptions}
            pageCount={Math.ceil(data.count / queryParams.limit)}
            marginPagesDisplayed={2}
            pageRangeDisplayed={0}
            onPageChange={({ selected }) => {
              document.body.scrollTop = document.documentElement.scrollTop = 0;
              setQueryParams({
                ...queryParams,
                page: selected + 1,
              });
            }}
            forcePage={queryParams.page - 1}
          />
        </div>
      </div>
      {showCreateNewCustomerModal && (
        <NewCustomerModal
          showCreateNewCustomerModal={showCreateNewCustomerModal}
          setShowCreateNewCustomerModal={setShowCreateNewCustomerModal}
          refetch={refetch}
        />
      )}
      {showEditCustomerModal && selectedCustomer ? (
        <EditCustomerModal
          showEditCustomerModal={showEditCustomerModal}
          setShowEditCustomerModal={setShowEditCustomerModal}
          selectedCustomer={selectedCustomer}
          setSelectedCustomer={setSelectedCustomer}
          refetch={refetch}
        />
      ) : null}
      {showSalesRepManager && selectedCustomer ? (
        <SetSalesRepModal
          selectedCustomer={selectedCustomer}
          setSelectedCustomer={setSelectedCustomer}
          setShowSaleRepModal={setShowSalesRepManager}
        />
      ) : null}
      {showProductModal && selectedCustomer ? (
        <CustomerProducts
          showProductModal={showProductModal}
          setShowProductModal={setShowProductModal}
          selectedCustomer={selectedCustomer}
          itemRefetch={refetch}
        />
      ) : null}
      <ModalLoader title="Downloading Excel..." show={isfetchingExcel} />
      <ModalLoader show={deleteCustomerMutation.isLoading} />
    </main>
  );
}
